import React, { useState } from 'react';
import { api_createCategories } from '../../../api/category';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { myToastWarning } from '../../../helpers/myToast';

interface SubType {
	name: string;
	description: string;
}

const AddCategory: React.FC = () => {
	const [loading, setLoading] = useState<boolean>(false);
	const [image, setImage] = useState<File | null>(null);
	const [name, setName] = useState<string>('');
	const [des, setDes] = useState<string>('');
	const [customSubTypes, setCustomSubTypes] = useState<SubType[]>([]);
	const [customSubSubTypes, setCustomSubSubTypes] = useState<SubType[]>([]);
	const [customSubSubSubTypes, setCustomSubSubSubTypes] = useState<SubType[]>([]);
	const navigate = useNavigate();

	const handleCustomSubTypeChange = (index: number, field: keyof SubType, value: string) => {
		const newCustomSubTypes = [...customSubTypes];
		newCustomSubTypes[index][field] = value;
		setCustomSubTypes(newCustomSubTypes);
	};

	const handleCustomSubSubTypeChange = (index: number, field: keyof SubType, value: string) => {
		const newCustomSubSubTypes = [...customSubSubTypes];
		newCustomSubSubTypes[index][field] = value;
		setCustomSubSubTypes(newCustomSubSubTypes);
	};

	const handleCustomSubSubSubTypeChange = (
		index: number,
		field: keyof SubType,
		value: string,
	) => {
		const newCustomSubSubSubTypes = [...customSubSubSubTypes];
		newCustomSubSubSubTypes[index][field] = value;
		setCustomSubSubSubTypes(newCustomSubSubSubTypes);
	};

	const handleSubCategory = () => {
		setCustomSubTypes([...customSubTypes, { name: '', description: '' }]);
	};
	const handleSubSubCategory = () => {
		setCustomSubSubTypes([...customSubSubTypes, { name: '', description: '' }]);
	};
	const handleSubSubSubCategory = () => {
		setCustomSubSubSubTypes([...customSubSubSubTypes, { name: '', description: '' }]);
	};

	const create = async () => {
		if (!image) {
			myToastWarning('Please Pick an Image!');
			return;
		}
		if (!name) {
			myToastWarning('Please Enter Name');
			return;
		}
		try {
			setLoading(true);
			const payload = new FormData();
			payload.append('name', name);
			payload.append('description', des);
			payload.append('image', image);

			// Append subCategories as FormData
			customSubTypes.forEach((subCategory, index) => {
				payload.append(`subCategories[${index}][name]`, subCategory.name);
				payload.append(`subCategories[${index}][description]`, subCategory.description);

				// Append subSubCategories if present
				if (customSubSubTypes) {
					customSubSubTypes.forEach((subSubCategory, subSubIndex) => {
						payload.append(
							`subCategories[${index}][subSubCategories][${subSubIndex}][name]`,
							subSubCategory.name,
						);
						payload.append(
							`subCategories[${index}][subSubCategories][${subSubIndex}][description]`,
							subSubCategory.description,
						);

						// Append subSubSubCategories if present
						if (customSubSubSubTypes) {
							customSubSubSubTypes.forEach((subSubSubCategory, subSubSubIndex) => {
								payload.append(
									`subCategories[${index}][subSubCategories][${subSubIndex}][subSubSubCategories][${subSubSubIndex}][name]`,
									subSubSubCategory.name,
								);
								payload.append(
									`subCategories[${index}][subSubCategories][${subSubIndex}][subSubSubCategories][${subSubSubIndex}][description]`,
									subSubSubCategory.description,
								);
							});
						}
					});
				}
			});

			const res = await api_createCategories(payload);
			const message = typeof res.message === 'string' ? res.message : 'Success';
			if (res.isSuccess) {
				toast.success(message);
				setTimeout(() => {
					navigate(-1);
				}, 100);
			}
		} catch (error) {
			console.error('Error creating category:', error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				flex: 1,
				padding: '40px',
			}}>
			<div className='mb-3'>
				<h3>Add Category</h3>
			</div>

			<div className='mb-3'>
				<label htmlFor='exampleFormControlInput1' className='form-label'>
					Name
				</label>
				<input
					value={name}
					onChange={(e) => setName(e.target.value)}
					style={{ width: '400px' }}
					className='form-control'
					id='exampleFormControlInput1'
					placeholder=''
				/>
			</div>
			<div className='mb-3'>
				<label htmlFor='formFileSm' className='form-label'>
					Product Image
				</label>
				<input
					onChange={(event) => {
						// @ts-ignore

						setImage(event.target.files[0]);
					}}
					style={{ width: '400px' }}
					className='form-control form-control-sm'
					id='formFileSm'
					type='file'
				/>
			</div>
			<div className='mb-3'>
				<label htmlFor='exampleFormControlTextarea1' className='form-label'>
					Description
				</label>
				<textarea
					value={des}
					onChange={(e) => setDes(e.target.value)}
					style={{ width: '400px' }}
					className='form-control'
					id='exampleFormControlTextarea1'
					rows={3}></textarea>
			</div>

			<div className='mb-3'>
				<button onClick={handleSubCategory} className='btn btn-secondary'>
					Add Sub Category
				</button>
			</div>

			{customSubTypes.map((subType, index) => (
				<div key={index} className='mb-3' style={{ width: '400px' }}>
					<input
						value={subType.name}
						onChange={(e) => handleCustomSubTypeChange(index, 'name', e.target.value)}
						className='form-control'
						placeholder='Enter sub type name'
					/>
					<input
						value={subType.description}
						onChange={(e) =>
							handleCustomSubTypeChange(index, 'description', e.target.value)
						}
						className='form-control'
						placeholder='Enter sub type description'
						style={{ marginTop: '10px' }}
					/>
					<div className='mb-3'>
						<button onClick={handleSubSubCategory} className='btn btn-secondary'>
							Add Sub Sub Category
						</button>
					</div>
				</div>
			))}

			{customSubSubTypes.map((subSubType, index) => (
				<div key={index} className='mb-3' style={{ width: '400px' }}>
					<input
						value={subSubType.name}
						onChange={(e) =>
							handleCustomSubSubTypeChange(index, 'name', e.target.value)
						}
						className='form-control'
						placeholder='Enter sub sub type name'
					/>
					<input
						value={subSubType.description}
						onChange={(e) =>
							handleCustomSubSubTypeChange(index, 'description', e.target.value)
						}
						className='form-control'
						placeholder='Enter sub sub type description'
						style={{ marginTop: '10px' }}
					/>
					<div className='mb-3'>
						<button onClick={handleSubSubSubCategory} className='btn btn-secondary'>
							Add Sub Sub Sub Category
						</button>
					</div>
				</div>
			))}

			{customSubSubSubTypes.map((subSubSubType, index) => (
				<div key={index} className='mb-3' style={{ width: '400px' }}>
					<input
						value={subSubSubType.name}
						onChange={(e) =>
							handleCustomSubSubSubTypeChange(index, 'name', e.target.value)
						}
						className='form-control'
						placeholder='Enter sub sub sub type name'
					/>
					<input
						value={subSubSubType.description}
						onChange={(e) =>
							handleCustomSubSubSubTypeChange(index, 'description', e.target.value)
						}
						className='form-control'
						placeholder='Enter sub sub sub type description'
						style={{ marginTop: '10px' }}
					/>
				</div>
			))}
			<button
				onClick={create}
				type='button'
				className='btn btn-lg btn-primary'
				disabled={loading}>
				{loading ? 'Loading..' : 'Submit'}
			</button>
		</div>
	);
};

export default AddCategory;
